<template>
  <div>
    <h1>Terms and conditions</h1>
    <p>
      Unmatched Maker is meant to be a safe, friendly, and fun space for all
      fans of Unmatched to share their enthusiasm for the game. We ask that you
      treat others with respect.
    </p>
    <p>
      While we hope not to, we reserve the right to remove any user-generated
      content and accounts, public or private, for any reason and at any time,
      at our sole discretion. If we do so, we will make our best efforts to
      contact you and let you know why.
    </p>
    <p>
      We will make our best efforts to safeguard your data, but we can't make
      any guarantees. We will not be held liable in any way for loss or exposure
      of your data.
    </p>
    <p>
      These terms and conditions may be updated from time to time.
    </p>
  </div>
</template>

<script>
export default {
  name: "TermsConditions",
  metaInfo: {
    title: "Terms and conditions"
  }
};
</script>
